import {
  getSpaceShapeLayout,
  RelativeVertex,
  SpaceShapeId
} from 'utils/space-polygon';

const U_UP_ICON_VERTICES: RelativeVertex[] = [
  { x: 0, y: 0 },
  { x: 5, y: 0 },
  { x: 5, y: 7 },
  { x: 11, y: 7 },
  { x: 11, y: 0 },
  { x: 16, y: 0 },
  { x: 16, y: 12 },
  { x: 0, y: 12 }
];

const U_DOWN_ICON_VERTICES: RelativeVertex[] = [
  { x: 0, y: 0 },
  { x: 16, y: 0 },
  { x: 16, y: 12 },
  { x: 11, y: 12 },
  { x: 11, y: 5 },
  { x: 5, y: 5 },
  { x: 5, y: 12 },
  { x: 0, y: 12 }
];

const U_LEFT_ICON_VERTICES: RelativeVertex[] = [
  { x: 0, y: 0 },
  { x: 12, y: 0 },
  { x: 12, y: 16 },
  { x: 0, y: 16 },
  { x: 0, y: 11 },
  { x: 7, y: 11 },
  { x: 7, y: 5 },
  { x: 0, y: 5 }
];

const U_RIGHT_ICON_VERTICES: RelativeVertex[] = [
  { x: 0, y: 0 },
  { x: 12, y: 0 },
  { x: 12, y: 5 },
  { x: 5, y: 5 },
  { x: 5, y: 11 },
  { x: 12, y: 11 },
  { x: 12, y: 16 },
  { x: 0, y: 16 }
];

const ICON_VERTEX_OVERRIDES: Partial<Record<SpaceShapeId, RelativeVertex[]>> = {
  'U-up': U_UP_ICON_VERTICES,
  'U-down': U_DOWN_ICON_VERTICES,
  'U-left': U_LEFT_ICON_VERTICES,
  'U-right': U_RIGHT_ICON_VERTICES
};

export function getShapeIconVertices(shape: SpaceShapeId): RelativeVertex[] {
  const override = ICON_VERTEX_OVERRIDES[shape];
  if (override) return override;
  return getSpaceShapeLayout(shape, { x: 0, y: 0 }).vertices;
}
